export const SEO_PAGES_2 = {
  "spotify-promotion": {
    title: "Spotify Promotion for Artists | Millionaire Connector",
    description:
      "Spotify promotion for Indian artists and labels — genre-targeted playlist campaigns on a network of 1,000+ active playlists, designed to reach relevant listeners. Get campaign details on WhatsApp.",
    overline: "Spotify Promotion",
    h1: "Spotify Promotion That Reaches",
    h1Highlight: "Real Listeners",
    intro:
      "Streams mean nothing if they come from the wrong ears. Our Spotify promotion places your track on genre-relevant playlists from our network of 1,000+ active playlists, in front of listeners who actually play your style of music.",
    sections: [
      {
        h: "What Our Spotify Promotion Includes",
        paras: [
          "We run playlist campaigns matched by genre and audience. Your track is pitched to curators whose playlists fit your sound — Punjabi, Haryanvi, Hindi, Bollywood-style, indie and more.",
        ],
        list: [
          "Genre-targeted playlist placement campaigns",
          "Playlist pitching to independent curators",
          "Campaign sizes from 10K to 100K+ streams",
          "Delivery paced to your order size",
          "Transparent delivery ranges and reporting",
        ],
      },
      {
        h: "Spotify Music Promotion — The Honest Version",
        paras: [
          "No agency can guarantee Discover Weekly, Release Radar or editorial placements — and you should not trust one that does. What well-matched playlist campaigns can do is put your track in front of relevant listeners, which can support discovery signals on the platform over time.",
        ],
      },
      {
        h: "Spotify Artist Promotion Paired With Reels",
        paras: [
          "The strongest Spotify growth we see comes when playlist campaigns run alongside Instagram Reels pushes. Reels create the demand; playlists capture it. Ask us about combined campaigns when you message.",
        ],
      },
    ],
    faqs: [
      {
        q: "What is Spotify promotion?",
        a: "Spotify promotion is the work of getting your track heard on the platform — primarily through genre-matched playlist placements that put your music in front of relevant listeners.",
      },
      {
        q: "Can you guarantee streams or editorial playlists?",
        a: "No. We commit to defined campaign sizes and genre-matched placements, but stream counts, saves and editorial decisions depend on listener behaviour and Spotify's own teams.",
      },
      {
        q: "Is Spotify promotion safe for my artist profile?",
        a: "We design campaigns around relevant, audience-matched playlists. We avoid anything that promises unrealistic numbers, because those are the campaigns that put profiles at risk.",
      },
    ],
    related: [
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "Spotify Playlist Pitching", to: "/spotify-playlist-pitching" },
      { label: "Spotify Promotion India", to: "/spotify-promotion-india" },
      { label: "Song Promotion Services", to: "/song-promotion" },
    ],
    cta: { title: "Get Spotify Campaign Details", label: "GET SPOTIFY DETAILS" },
    serviceName: "Spotify Promotion",
    serviceDesc:
      "Spotify promotion for artists and labels through genre-targeted playlist campaigns designed to reach relevant listeners.",
  },

  "spotify-playlist-promotion": {
    title: "Spotify Playlist Promotion & Music Promotion India | Millionaire Connector",
    description:
      "Spotify playlist promotion on a network of 1,000+ active playlists — campaign slots from ₹5,000 (10K–12K streams) to ₹32,000 (100K–105K streams). 800+ clients, 3M+ monthly streams. Book on WhatsApp.",
    overline: "Spotify Playlist Promotion",
    h1: "Spotify Playlist Promotion,",
    h1Highlight: "Matched To Your Genre",
    intro:
      "Playlist promotion works when the playlist fits the song. Our Spotify playlist promotion service is built on a network of 1,000+ active playlists, trusted by 800+ clients, with client campaigns collectively generating 3M+ streams per month.",
    showPricing: true,
    showProof: true,
    sections: [
      {
        h: "How Spotify Playlist Promotion Works",
        paras: [
          "You send the track. We identify playlists from our 1,000+ active playlist network whose audiences match your genre and language. Your track is placed across a campaign sized to your goals, and you receive updates as delivery progresses.",
          "We handle both smaller campaigns and high-volume orders, with delivery pace structured according to the size and requirements of the campaign.",
        ],
      },
      {
        h: "Campaign Slots & Pricing",
        paras: [
          "Clear stream ranges, clear pricing — pick the slot that fits your release:",
        ],
        list: [
          "10K–12K streams — ₹5,000",
          "20K–22K streams — ₹9,000",
          "30K–33K streams — ₹12,000",
          "50K–53K streams — ₹17,000",
          "100K–105K streams — ₹32,000",
        ],
      },
      {
        h: "Delivery, Paced To Your Order",
        paras: [
          "Delivery speed is based on campaign size and selected slot. Smaller campaigns are generally paced around 1.5K–2K streams/day, while larger campaigns can be scaled to 10K+ streams/day depending on campaign requirements.",
          "Delivery speed and campaign performance can vary depending on playlist availability, audience behaviour and campaign conditions.",
        ],
      },
      {
        h: "What Playlist Promotion Can And Cannot Do",
        paras: [
          "Well-matched playlist campaigns are designed to reach relevant listeners and can support discovery signals over time. They cannot guarantee saves, followers, or Spotify editorial placements like Discover Weekly — those depend on listener response and Spotify's editorial teams.",
        ],
      },
    ],
    faqs: [
      {
        q: "What is Spotify playlist promotion?",
        a: "It is the placement of your track on genre-relevant playlists so it reaches listeners who already enjoy your style of music. Our campaigns run on a network of 1,000+ active playlists, matched by genre and audience.",
      },
      {
        q: "How fast will my campaign deliver?",
        a: "Delivery speed depends on campaign size and selected slot — smaller campaigns are generally paced around 1.5K–2K streams/day, while larger campaigns can scale to 10K+ streams/day depending on requirements.",
      },
      {
        q: "Will playlist promotion get me on Discover Weekly?",
        a: "No one can guarantee algorithmic or editorial placements. Relevant playlist campaigns can support the discovery signals that those systems respond to.",
      },
    ],
    related: [
      { label: "Spotify Playlist Promotion Service", to: "/spotify-playlist-promotion-service" },
      { label: "Spotify Playlist Pitching", to: "/spotify-playlist-pitching" },
      { label: "Spotify Promotion", to: "/spotify-promotion" },
      { label: "Song Promotion Services", to: "/song-promotion" },
    ],
    cta: { title: "Ready To Book Your Spotify Slot?", label: "BOOK YOUR SPOTIFY SLOT" },
    serviceName: "Spotify Playlist Promotion",
    serviceDesc:
      "Spotify playlist promotion on a network of 1,000+ active playlists, with campaign slots from 10K to 100K+ streams and delivery paced to order size.",
  },

  "spotify-playlist-promotion-service": {
    title: "Spotify Playlist Promotion Service | Millionaire Connector",
    description:
      "A Spotify playlist promotion service built for Indian music — 1,000+ active playlists, campaign slots from ₹5,000 to ₹32,000, delivery paced to order size, honest reporting. WhatsApp us your track.",
    overline: "Playlist Promotion Service",
    h1: "A Spotify Playlist Promotion Service You Can",
    h1Highlight: "Actually Trust",
    intro:
      "The playlisting world is full of vague promises. Our Spotify playlist promotion service is built on the opposite: defined campaign slots, genre-matched placements from a network of 1,000+ active playlists, and reporting you can verify.",
    showPricing: true,
    sections: [
      {
        h: "What The Service Delivers",
        paras: [
          "Every campaign includes playlist matching by genre and audience, placement across a defined campaign slot, and delivery updates. You know what you booked, and you see what landed.",
        ],
        list: [
          "10K–12K streams — ₹5,000",
          "20K–22K streams — ₹9,000",
          "30K–33K streams — ₹12,000",
          "50K–53K streams — ₹17,000",
          "100K–105K streams — ₹32,000",
        ],
      },
      {
        h: "Spotify Playlist Placement, Done Responsibly",
        paras: [
          "We match playlists by genre and audience because relevance is what makes streams meaningful. A Haryanvi track on a Haryanvi-heavy playlist outperforms the same track dumped into a generic mix — for the artist and the listener.",
          "Delivery speed is based on campaign size and selected slot: smaller campaigns are generally paced around 1.5K–2K streams/day, while larger campaigns can be scaled to 10K+ streams/day depending on campaign requirements.",
        ],
      },
      {
        h: "Our Promises, In Writing",
        paras: [
          "We promise defined campaign slots, genre-matched placements and transparent reporting. We do not promise guaranteed saves, followers, editorial playlists or algorithmic boosts — because nobody honestly can. Delivery speed and performance can vary with playlist availability, audience behaviour and campaign conditions.",
        ],
      },
    ],
    faqs: [
      {
        q: "What does a Spotify playlist promotion service include?",
        a: "Genre and audience matching across a network of 1,000+ active playlists, placement across a defined campaign slot, and delivery reporting — from ₹5,000 (10K–12K streams) to ₹32,000 (100K–105K streams).",
      },
      {
        q: "How do I choose a campaign slot?",
        a: "Match it to your release goals: 10K–20K suits testing a new sound, 30K–50K suits a serious single push, 100K+ suits major releases. We will advise based on your track.",
      },
      {
        q: "When does the campaign start after booking?",
        a: "Campaigns typically begin within days of confirmation, once playlist matching for your genre is complete.",
      },
    ],
    related: [
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "Spotify Promotion", to: "/spotify-promotion" },
      { label: "Spotify Promotion India", to: "/spotify-promotion-india" },
      { label: "Music Promotion", to: "/music-promotion" },
    ],
    cta: { title: "Ready To Book Your Spotify Slot?", label: "BOOK YOUR SPOTIFY SLOT" },
    serviceName: "Spotify Playlist Promotion Service",
    serviceDesc:
      "Spotify playlist promotion service with defined campaign slots, genre-matched placements from 1,000+ active playlists and transparent delivery reporting for Indian artists.",
  },

  "spotify-playlist-pitching": {
    title: "Spotify Playlist Pitching | Millionaire Connector",
    description:
      "Spotify playlist pitching for Indian artists — curator outreach across a 1,000+ active playlist network, genre positioning and campaign-managed placements that put your track in front of relevant listeners.",
    overline: "Spotify Playlist Pitching",
    h1: "Spotify Playlist Pitching That Gets Your Track",
    h1Highlight: "Heard By Curators",
    intro:
      "Great tracks get skipped every day because nobody pitched them properly. Spotify playlist pitching is the craft of presenting your song to the right curators, with the right positioning, at the right time.",
    sections: [
      {
        h: "What Is Spotify Playlist Pitching?",
        paras: [
          "Pitching means presenting your track to playlist curators — both through Spotify for Artists (for editorial consideration) and directly to independent curators who run genre playlists. The pitch carries your genre, mood, language and story so curators can place the track where it fits.",
        ],
      },
      {
        h: "How We Pitch Your Music",
        paras: [
          "We position your track by genre, language and audience, then pitch it across our network of 1,000+ active playlists as part of a defined campaign. You get placements on relevant playlists — not random adds on lists that nobody in your genre reads.",
        ],
        list: [
          "Genre and language positioning for every pitch",
          "Independent curator outreach across Indian and international playlists",
          "Campaign-managed placements with delivery reporting",
          "Guidance on your own Spotify for Artists editorial pitch",
        ],
      },
      {
        h: "Pitching Vs Guaranteed Placement",
        paras: [
          "Pitching improves your odds with real curators; it cannot force their decisions. Likewise, Spotify's editorial team makes its own calls. We pitch hard and place wide — and we never sell 'guaranteed editorial' because that promise is always fake.",
        ],
      },
    ],
    faqs: [
      {
        q: "What is Spotify playlist pitching?",
        a: "It is presenting your track to playlist curators — Spotify's editorial team via Spotify for Artists, and independent curators directly — with the right genre positioning and timing to earn relevant placements.",
      },
      {
        q: "When should I pitch my song to Spotify editorial?",
        a: "At least seven days before release through Spotify for Artists. We handle independent curator pitching alongside, and can guide your editorial pitch timing.",
      },
      {
        q: "Does pitching guarantee playlist placement?",
        a: "No. Pitching earns consideration; curators decide. Our campaigns combine pitching with managed placements so you get defined delivery, not just hope.",
      },
    ],
    related: [
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "Spotify Playlist Promotion Service", to: "/spotify-playlist-promotion-service" },
      { label: "Spotify Promotion", to: "/spotify-promotion" },
      { label: "Independent Artist Promotion", to: "/independent-artist-promotion" },
    ],
    cta: { title: "Pitch My Track To Playlists", label: "GET SPOTIFY DETAILS" },
    serviceName: "Spotify Playlist Pitching",
    serviceDesc:
      "Spotify playlist pitching services: curator outreach, genre positioning and campaign-managed placements across a 1,000+ active playlist network for Indian artists and labels.",
  },

  "spotify-promotion-india": {
    title: "Spotify Promotion India | Millionaire Connector",
    description:
      "Spotify promotion in India for Punjabi, Haryanvi, Hindi and Bollywood releases — genre-matched playlist campaigns on 1,000+ active playlists, with pricing from ₹5,000 and delivery paced to order size.",
    overline: "Spotify Promotion India",
    h1: "Spotify Promotion In India For",
    h1Highlight: "Indian Sound",
    intro:
      "India is one of Spotify's fastest-growing markets — and one of the most regional. Spotify promotion in India needs playlists that match not just genre, but language and culture.",
    sections: [
      {
        h: "Spotify Playlist Pitching In India",
        paras: [
          "Indian listening is organised around language: Punjabi playlists, Haryanvi playlists, Hindi and Bollywood playlists, Rajasthani folk mixes. Our Spotify playlist pitching in India targets curators from our 1,000+ active playlist network who run exactly these lists, so your track lands where its audience already lives.",
        ],
      },
      {
        h: "Campaigns For Indian Artists & Labels",
        paras: [
          "Campaign slots run from ₹5,000 (10K–12K streams) to ₹32,000 (100K–105K streams), every one genre and audience matched. Delivery speed is based on campaign size and selected slot — smaller campaigns are generally paced around 1.5K–2K streams/day, while larger campaigns can be scaled to 10K+ streams/day depending on campaign requirements.",
        ],
      },
      {
        h: "Pairing Spotify With Reels In India",
        paras: [
          "In India, the winning pattern is Reels-first: creators make the audio familiar, then listeners search and stream it. Running Spotify playlist promotion alongside a Reels campaign captures that demand instead of losing it.",
        ],
      },
    ],
    faqs: [
      {
        q: "How does Spotify promotion in India work?",
        a: "Campaigns place your track on language and genre-matched playlists from our 1,000+ active playlist network — Punjabi, Haryanvi, Hindi, Bollywood — with slots from ₹5,000 to ₹32,000 and delivery paced to order size.",
      },
      {
        q: "Do you run Spotify campaigns for Punjabi and Haryanvi songs?",
        a: "Yes — they are two of our strongest categories, matched to playlists whose audiences follow those genres.",
      },
      {
        q: "Can Spotify promotion grow my monthly listeners?",
        a: "Relevant playlist placements put your track in front of new listeners, which can grow monthly listeners over time. Exact numbers depend on listener response — we never guarantee them.",
      },
    ],
    related: [
      { label: "Spotify Promotion", to: "/spotify-promotion" },
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "Song Promotion India", to: "/song-promotion-india" },
      { label: "Music Promotion India", to: "/music-promotion-india" },
    ],
    cta: { title: "Start Spotify Promotion In India", label: "BOOK YOUR SPOTIFY SLOT" },
    serviceName: "Spotify Promotion India",
    serviceDesc:
      "Spotify promotion in India with language and genre matched playlist campaigns for Punjabi, Haryanvi, Hindi and Bollywood releases.",
  },

  "creator-marketing": {
    title: "Creator Marketing for Music | Millionaire Connector",
    description:
      "Creator marketing for music releases — 250+ creators per region across Punjab, Haryana, Rajasthan and Hindi markets, plus 300+ nano influencers. Plan your creator campaign on WhatsApp.",
    overline: "Creator Marketing",
    h1: "Creator Marketing With India\u2019s",
    h1Highlight: "Music Creators",
    intro:
      "Creators are the new radio. Our creator marketing network spans 250+ creators per major region and 300+ nano influencers — all organised for one purpose: making music move.",
    sections: [
      {
        h: "A Creator Network Built For Music",
        paras: [
          "Our network is not a scraped influencer list. It is a working ecosystem of creators who post music content every day, organised by region, language and content style.",
        ],
        list: [
          "Haryana — 250+ verified creators",
          "Rajasthan — 250+ influencers",
          "Punjab — 250+ content creators",
          "Hindi — 250+ pan-India specialists",
          "Punjab & Haryana nano creators — 300+ micro-influencers",
        ],
      },
      {
        h: "How Creator Campaigns Are Built",
        paras: [
          "We match creators to your track by audience first: who follows them, what language they speak, what content style they own. Then we brief, schedule and coordinate the posting window — and report what the campaign delivered.",
        ],
      },
      {
        h: "Beyond Music: Brand Campaigns",
        paras: [
          "The same network powers brand promotion — product launches, regional brand pushes and anthem campaigns. If your brand needs Indian regional reach, the creators are already here.",
        ],
      },
    ],
    faqs: [
      {
        q: "What is creator marketing for music?",
        a: "It is promoting your song through content creators who publish Reels and posts using your audio — matched to your genre, language and target regions.",
      },
      {
        q: "How many creators can work on one campaign?",
        a: "Campaigns range from dozens of creators for focused pushes to thousands of posts per day in bulk campaigns, thanks to our regional and nano-creator layers.",
      },
      {
        q: "Do creators disclose paid campaigns?",
        a: "We expect creators to follow platform guidelines on branded content. Campaign structures are discussed transparently before launch.",
      },
    ],
    related: [
      { label: "Music Influencer Marketing", to: "/music-influencer-marketing" },
      { label: "Instagram Reels Promotion", to: "/instagram-reels-promotion" },
      { label: "Song Promotion Agency", to: "/song-promotion-agency" },
      { label: "Music Promotion India", to: "/music-promotion-india" },
    ],
    cta: { title: "Put 250+ Creators Behind Your Release", label: "PLAN MY CAMPAIGN" },
    serviceName: "Creator Marketing",
    serviceDesc:
      "Creator marketing for music releases through regional creator networks across Punjab, Haryana, Rajasthan and pan-India Hindi markets.",
  },

  "music-influencer-marketing": {
    title: "Music Influencer Marketing | Millionaire Connector",
    description:
      "Music influencer marketing for Indian artists and brands — influencer campaigns across Instagram built for song discovery, audio trends and regional reach. 800+ clients served.",
    overline: "Music Influencer Marketing",
    h1: "Music Influencer Marketing That",
    h1Highlight: "Starts Trends",
    intro:
      "When the right influencer posts your hook, thousands follow. Music influencer marketing is about choosing those voices carefully — by region, genre and audience — then coordinating them into a wave.",
    sections: [
      {
        h: "Influencers Vs Creators — And Why You Need Both",
        paras: [
          "Larger influencers give your track authority and reach spikes. Mid and nano creators give it volume and authenticity. Our campaigns layer all three, so the audio feels like a genuine wave rather than a single paid post.",
        ],
      },
      {
        h: "Instagram Influencer Promotion For Music",
        paras: [
          "Our Instagram influencer promotion runs through music-focused pages and regional influencers across Punjab, Haryana, Rajasthan and the Hindi market — the same ecosystem behind campaigns reaching 1.7M+ reels.",
        ],
        list: [
          "Region-matched influencer selection",
          "Hook-first content briefing",
          "Coordinated posting windows",
          "Layered nano-to-influencer distribution",
          "Campaign reporting on delivery",
        ],
      },
      {
        h: "Influencer Marketing For Brands In Music",
        paras: [
          "Brands riding music culture — beverage launches, app campaigns, fashion drops — use our network to enter regional conversations through sound. Music influencer marketing works beyond the music industry.",
        ],
      },
    ],
    faqs: [
      {
        q: "What is music influencer marketing?",
        a: "It is promoting music through influencers and creators who publish content using your track — selected by region, genre and audience for maximum discovery.",
      },
      {
        q: "How do you choose influencers for a song?",
        a: "By audience match first: language, region, content style and engagement quality — then by fit with the track's mood and hook.",
      },
      {
        q: "Can influencer marketing make a song trend?",
        a: "Coordinated influencer campaigns create the conditions for trending — volume, timing and regional relevance. No honest agency guarantees a trend; we build the wave and your hook rides it.",
      },
    ],
    related: [
      { label: "Creator Marketing", to: "/creator-marketing" },
      { label: "Instagram Reels Promotion Agency", to: "/instagram-reels-promotion-agency" },
      { label: "Music Promotion", to: "/music-promotion" },
      { label: "Song Promotion on Instagram", to: "/song-promotion-instagram" },
    ],
    cta: { title: "Launch An Influencer Wave For Your Track", label: "START MY CAMPAIGN" },
    serviceName: "Music Influencer Marketing",
    serviceDesc:
      "Music influencer marketing through region-matched influencer and creator campaigns across Instagram for artists, labels and brands.",
  },

  "independent-artist-promotion": {
    title: "Independent Artist Promotion | Millionaire Connector",
    description:
      "Promotion for independent artists in India — affordable, focused campaigns across Spotify playlists, Instagram Reels and lyrics pages. Slots from ₹5,000. Send your track on WhatsApp.",
    overline: "Independent Artist Promotion",
    h1: "Independent Artist Promotion,",
    h1Highlight: "Without A Label",
    intro:
      "You do not need a label to be heard — you need distribution. Independent artist promotion at Millionaire Connector gives you the same playlist network and creator ecosystems that labels use, sized to an independent budget.",
    sections: [
      {
        h: "The Independent Artist Playbook",
        paras: [
          "Concentrate, don't scatter. The independent artists who grow fastest put their budget into one or two channels per release: a Spotify playlist campaign for streams, and a creator-led Reels campaign for discovery. That is the core playbook we run.",
        ],
      },
      {
        h: "What We Do For Independent Artists",
        paras: [
          "Everything a label's marketing team would coordinate, without the label:",
        ],
        list: [
          "Release strategy — which channels, which regions, what volume",
          "Spotify playlist campaigns from ₹5,000, paced to your order",
          "Creator-led Reels campaigns matched to your genre",
          "Lyrics-page placements for Punjabi and Haryanvi artists",
          "Clear reporting so every rupee is accounted for",
        ],
      },
      {
        h: "Honest Advice For Independent Artists",
        paras: [
          "Promotion amplifies a song; it cannot replace one. Bring us a track you believe in, and we will build the loudest campaign your budget allows. Bring us ten weak tracks, and no campaign will save them. We would rather tell you that upfront.",
        ],
      },
    ],
    faqs: [
      {
        q: "How can independent artists promote their music in India?",
        a: "Focus budget on one or two channels per release — typically a Spotify playlist campaign plus a creator-led Reels push — instead of spreading thin across every platform.",
      },
      {
        q: "Can independent artists afford professional promotion?",
        a: "Yes. Spotify campaign slots start at ₹5,000 and Reels campaigns scale to budget. Message us your track and budget range and we will recommend the highest-impact structure.",
      },
      {
        q: "Do independent artists get the same networks as labels?",
        a: "Yes. The same playlist network, creator ecosystems and lyrics pages — sized to your campaign.",
      },
    ],
    related: [
      { label: "Song Promotion Services", to: "/song-promotion" },
      { label: "Spotify Playlist Promotion", to: "/spotify-playlist-promotion" },
      { label: "Spotify Playlist Pitching", to: "/spotify-playlist-pitching" },
      { label: "Instagram Reels Promotion", to: "/instagram-reels-promotion" },
    ],
    cta: { title: "Promote Your Music Independently", label: "PROMOTE MY MUSIC" },
    serviceName: "Independent Artist Promotion",
    serviceDesc:
      "Promotion services for independent artists in India: Spotify playlist campaigns, creator-led Reels campaigns and lyrics pages sized to independent budgets.",
  },
};
